import { render, staticRenderFns } from "./gaps-in-service.vue?vue&type=template&id=18c56fba"
import script from "./gaps-in-service.vue?vue&type=script&lang=js"
export * from "./gaps-in-service.vue?vue&type=script&lang=js"
import style0 from "./gaps-in-service.vue?vue&type=style&index=0&id=18c56fba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports